class UseDomainEvent {
  constructor() {
    if (!window.cookieStore) return;

    window.cookieStore.addEventListener('change', e => {
      const cookieValue = e.changed[0]?.value;
      if (!cookieValue) return;
      const [fromHostname, eventType] = cookieValue.split('/');
      if (fromHostname === location.hostname) return; // without self
      if (['LOGIN', 'LOGOUT'].includes(eventType)) window.location.reload();
    });
  }

  dispatch(type) {
    if (!location.hostname) return false;
    const domainEventKey = '__domain-event';
    const parentDomain = location.hostname.substring(location.hostname.indexOf('.') + 1);
    document.cookie = `${domainEventKey}=${location.hostname}/${type}; domain=${parentDomain}; expires=${new Date(
      Date.now() + 1000,
    ).toUTCString()}; path=/`;
    return true;
  }
}

export const domainEvent = new UseDomainEvent();
